export default __webpack_public_path__ + "static/media/timer-cloth-icon.3b95a8ac.png";